import { render, staticRenderFns } from "./UpdateResourceDetailSectionDialog.vue?vue&type=template&id=5db78d18"
import script from "./UpdateResourceDetailSectionDialog.vue?vue&type=script&lang=js"
export * from "./UpdateResourceDetailSectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports